import { COLORS } from "constants/colorScheme";
import styled, { css } from "styled-components";

export const PublishStatusWrapper = styled.div`
  margin-left: 32px;
`;

export const BackButtonWrapper = styled.div`
  display: flex;
  margin-left: 26px;
`;

export const Container = styled.div`
  padding: 32px;
  background-color: ${COLORS.WHITE};
  border-radius: 10px;
`;

export const ControlsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 40px;
`;

export const ControlContainer = styled.div`
  ${({ width }: { width?: string }) =>
    css`
      width: ${width ?? "120px"};
    `}
  &:not(:last-child) {
    margin-right: 32px;
  }
`;
